// Named handler so SPA navigation can remove it (anonymous listeners leak).
function warnOnTabClose(event) {
  event.preventDefault();
  event.returnValue = "";
}

export function attachLeaveGuard() {
  window.addEventListener("beforeunload", warnOnTabClose);
  document.body.classList.add("overflow-hidden");
}

export function detachLeaveGuard() {
  window.removeEventListener("beforeunload", warnOnTabClose);
  document.body.classList.remove("overflow-hidden");
}
